import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getPickToPackTime = {
  name: "getPickToPackTime" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
